export default __webpack_public_path__ + "static/media/img-slide-4.7da0405d.jpeg";